import { init } from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

import { constants } from '../../constants';

init({
  dsn: 'https://ecedb27b927f47f8a7d8027986fe8085@o72355.ingest.sentry.io/155981',
  release: constants.appVersion,
  integrations: [new BrowserTracing()],
  environment: constants.mode,
  enabled: !constants.isLocal,
});
